<template>
  <div class="table-responsive">
    <table-component
      ref="table"
      :show-filter="false"
      :data="prepaymentRequest"
      table-class="table"
    >
      <table-column
        :label="$t('pos.offer_date')"
        show="formattedPrePaymentDate"
      />

      <!-- v-if="
          userType === 'anchor' ||
            userType === 'super_admin' ||
            userType === 'supplier'
        " -->
      <table-column :label="$t('general.promised_payment_date')">
        <template slot-scope="row">
          <!-- <p
            v-if="
              $route.name === 'preapproved-invoice-request-view-supplier' ||
                $route.name === 'preapproved.invoice.offer'
            "
          >
            {{ row.invoice.formattedPromisedPaymentDate }}
          </p> -->
          <p>{{ row.formattedPromisedPaymentDate }}</p>
        </template>
      </table-column>

      <!-- <table-column v-else :label="$t('general.promised_payment_date')">
        <template slot-scope="row">
          <p>{{ row.formattedPromisedPaymentDate }}</p>
        </template>
      </table-column> -->

      <table-column
        v-if="userType == 'supplier' || userType == 'funder'"
        :label="$t('prepayments.offer_expire')"
        show="formattedOfferExpire"
      >
        <template slot-scope="row">
          <span>{{ $t("general.offer_amount") }}</span>
          <div v-html="row.formattedOfferExpire" />
        </template>
      </table-column>
      <table-column
        :label="$t('general.request_number')"
        show="prepayment_number"
      />
      <table-column
        v-if="userType == 'super_admin'"
        :label="$t('prepayments.offer_requested_on_date')"
        show="formattedSupplierOfferRequestDate"
      >
        <template slot-scope="row">
          <span>{{ $t("prepayments.offer_requested_on_date") }}</span>
          <div v-html="row.formattedSupplierOfferRequestDate" />
        </template>
      </table-column>
      <table-column
        :label="$t('general.request_amount')"
        sort-as="request_amount"
      >
        <template slot-scope="row">
          <span>{{ $t("general.request_amount") }}</span>
          <div
            v-html="
              $utils.formatMoney(
                row.requested_amount,
                row.purchase_order.user.account.currency
              )
            "
          />
        </template>
      </table-column>
      <table-column :label="$t('general.offer_amount')" sort-as="total">
        <template slot-scope="row">
          <span>{{ $t("general.offer_amount") }}</span>
          <div
            v-html="
              $utils.formatMoney(
                row.amount,
                row.purchase_order.user.account.currency
              )
            "
          />
        </template>
      </table-column>
      <table-column
        :label="$t('prepayments.rate_of_pre_payment')"
        show="rate_of_prepayment"
      >
        <template slot-scope="row">
          <span>{{ $t("prepayments.amount") }}</span>
          {{ row.rate_of_prepayment }} %
        </template>
      </table-column>
      <table-column
        v-if="
          userType == 'funder' ||
            userType == 'super_admin' ||
            userType == 'supplier'
        "
        :label="$t('general.financing_ratio')"
        show="margin"
      >
        <template slot-scope="row">
          <span>{{ $t("general.financing_ratio") }}</span>
          {{ row.margin_rate }} %
        </template>
      </table-column>
      <table-column
        :label="$t('prepayments.supplier_comment')"
        show="supplier_comment"
      />
      <table-column
        :label="$t('prepayments.anchor_comment')"
        show="anchor_comment"
      />
      <table-column
        :label="$t('prepayments.administrator_comment')"
        show="superAdmin_comment"
      />
    </table-component>
  </div>
</template>
<script>
export default {
  props: {
    prepaymentRequest: { default: () => [], type: [Array, Function] },
    tableDivId: { default: '', type: String }
  },
  data () {
    return {
      percentageFormatMoneyComponent: {
        decimal: '.',
        thousands: ',',
        prefix: '% ',
        precision: 2,
        masked: false
      },
      userType: null
    }
  },
  created () {
    if (localStorage.getItem('role') === 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') === 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') === 'supplier') {
      this.userType = 'supplier'
    } else if (localStorage.getItem('account_type') === 'funder') {
      this.userType = 'funder'
    }
  }
}
</script>
